import { onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';

export const RECOMMENDATION_SETTINGS_PARAM = 'recommendationSettings';

// Deep link into the Recommendation Settings drawer/sheet: consume the param once on mount,
// then strip it so a refresh doesn't reopen the panel (same shape as the firstRun handoff).
export function useSettingsDeepLink(showRecommendationSettings) {
	const route = useRoute();
	const router = useRouter();

	// Read at setup: the selectedJob watcher rewrites the query to just { jobId } once a job
	// is auto-selected, which can land before onMounted.
	const isRequested = route.query?.[RECOMMENDATION_SETTINGS_PARAM] === '1';

	onMounted(() => {
		if (!isRequested) {
			return;
		}

		// Flipped here rather than at setup so the drawer plays its enter transition.
		showRecommendationSettings.value = true;

		const query = { ...route.query };
		delete query[RECOMMENDATION_SETTINGS_PARAM];
		router.replace({ path: route.path, query });
	});
}
